module.exports = __webpack_public_path__ + "assets/img/close_icon.d7477992.png";